import { Module } from 'owa-workloads';
import { action } from 'satcheljs';

export default action('updateModule', (newModule: Module, currentModule?: Module) => ({
    newModule,
    currentModule,
}));
